/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ResponseUserWeeklyScheduleExceptionDto } from '../models/response-user-weekly-schedule-exception-dto';
import { userWeeklyScheduleExceptionsControllerCreate } from '../fn/user-weekly-schedule-exceptions/user-weekly-schedule-exceptions-controller-create';
import { UserWeeklyScheduleExceptionsControllerCreate$Params } from '../fn/user-weekly-schedule-exceptions/user-weekly-schedule-exceptions-controller-create';
import { userWeeklyScheduleExceptionsControllerDelete } from '../fn/user-weekly-schedule-exceptions/user-weekly-schedule-exceptions-controller-delete';
import { UserWeeklyScheduleExceptionsControllerDelete$Params } from '../fn/user-weekly-schedule-exceptions/user-weekly-schedule-exceptions-controller-delete';
import { userWeeklyScheduleExceptionsControllerFindAllByEmail } from '../fn/user-weekly-schedule-exceptions/user-weekly-schedule-exceptions-controller-find-all-by-email';
import { UserWeeklyScheduleExceptionsControllerFindAllByEmail$Params } from '../fn/user-weekly-schedule-exceptions/user-weekly-schedule-exceptions-controller-find-all-by-email';
import { userWeeklyScheduleExceptionsControllerFindOne } from '../fn/user-weekly-schedule-exceptions/user-weekly-schedule-exceptions-controller-find-one';
import { UserWeeklyScheduleExceptionsControllerFindOne$Params } from '../fn/user-weekly-schedule-exceptions/user-weekly-schedule-exceptions-controller-find-one';
import { userWeeklyScheduleExceptionsControllerUpdate } from '../fn/user-weekly-schedule-exceptions/user-weekly-schedule-exceptions-controller-update';
import { UserWeeklyScheduleExceptionsControllerUpdate$Params } from '../fn/user-weekly-schedule-exceptions/user-weekly-schedule-exceptions-controller-update';

@Injectable({ providedIn: 'root' })
export class UserWeeklyScheduleExceptionsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userWeeklyScheduleExceptionsControllerCreate()` */
  static readonly UserWeeklyScheduleExceptionsControllerCreatePath = '/thalea-google-events/user-weekly-schedule-exceptions';

  /**
   * Create a new weekly schedule exception.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userWeeklyScheduleExceptionsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userWeeklyScheduleExceptionsControllerCreate$Response(params: UserWeeklyScheduleExceptionsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseUserWeeklyScheduleExceptionDto>> {
    return userWeeklyScheduleExceptionsControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new weekly schedule exception.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userWeeklyScheduleExceptionsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userWeeklyScheduleExceptionsControllerCreate(params: UserWeeklyScheduleExceptionsControllerCreate$Params, context?: HttpContext): Observable<ResponseUserWeeklyScheduleExceptionDto> {
    return this.userWeeklyScheduleExceptionsControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseUserWeeklyScheduleExceptionDto>): ResponseUserWeeklyScheduleExceptionDto => r.body)
    );
  }

  /** Path part for operation `userWeeklyScheduleExceptionsControllerFindOne()` */
  static readonly UserWeeklyScheduleExceptionsControllerFindOnePath = '/thalea-google-events/user-weekly-schedule-exceptions/{tenant}/{email}/{createdAt}';

  /**
   * Get a specific weekly schedule exception by tenant, email, and createdAt.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userWeeklyScheduleExceptionsControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  userWeeklyScheduleExceptionsControllerFindOne$Response(params: UserWeeklyScheduleExceptionsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseUserWeeklyScheduleExceptionDto>> {
    return userWeeklyScheduleExceptionsControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a specific weekly schedule exception by tenant, email, and createdAt.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userWeeklyScheduleExceptionsControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userWeeklyScheduleExceptionsControllerFindOne(params: UserWeeklyScheduleExceptionsControllerFindOne$Params, context?: HttpContext): Observable<ResponseUserWeeklyScheduleExceptionDto> {
    return this.userWeeklyScheduleExceptionsControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseUserWeeklyScheduleExceptionDto>): ResponseUserWeeklyScheduleExceptionDto => r.body)
    );
  }

  /** Path part for operation `userWeeklyScheduleExceptionsControllerDelete()` */
  static readonly UserWeeklyScheduleExceptionsControllerDeletePath = '/thalea-google-events/user-weekly-schedule-exceptions/{tenant}/{email}/{createdAt}';

  /**
   * Delete a weekly schedule exception.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userWeeklyScheduleExceptionsControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  userWeeklyScheduleExceptionsControllerDelete$Response(params: UserWeeklyScheduleExceptionsControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userWeeklyScheduleExceptionsControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a weekly schedule exception.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userWeeklyScheduleExceptionsControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userWeeklyScheduleExceptionsControllerDelete(params: UserWeeklyScheduleExceptionsControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.userWeeklyScheduleExceptionsControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userWeeklyScheduleExceptionsControllerUpdate()` */
  static readonly UserWeeklyScheduleExceptionsControllerUpdatePath = '/thalea-google-events/user-weekly-schedule-exceptions/{tenant}/{email}/{createdAt}';

  /**
   * Update an existing weekly schedule exception.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userWeeklyScheduleExceptionsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userWeeklyScheduleExceptionsControllerUpdate$Response(params: UserWeeklyScheduleExceptionsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseUserWeeklyScheduleExceptionDto>> {
    return userWeeklyScheduleExceptionsControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update an existing weekly schedule exception.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userWeeklyScheduleExceptionsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userWeeklyScheduleExceptionsControllerUpdate(params: UserWeeklyScheduleExceptionsControllerUpdate$Params, context?: HttpContext): Observable<ResponseUserWeeklyScheduleExceptionDto> {
    return this.userWeeklyScheduleExceptionsControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseUserWeeklyScheduleExceptionDto>): ResponseUserWeeklyScheduleExceptionDto => r.body)
    );
  }

  /** Path part for operation `userWeeklyScheduleExceptionsControllerFindAllByEmail()` */
  static readonly UserWeeklyScheduleExceptionsControllerFindAllByEmailPath = '/thalea-google-events/user-weekly-schedule-exceptions/{tenant}/{email}';

  /**
   * Get all weekly schedule exceptions for a specific user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userWeeklyScheduleExceptionsControllerFindAllByEmail()` instead.
   *
   * This method doesn't expect any request body.
   */
  userWeeklyScheduleExceptionsControllerFindAllByEmail$Response(params: UserWeeklyScheduleExceptionsControllerFindAllByEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseUserWeeklyScheduleExceptionDto>>> {
    return userWeeklyScheduleExceptionsControllerFindAllByEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all weekly schedule exceptions for a specific user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userWeeklyScheduleExceptionsControllerFindAllByEmail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userWeeklyScheduleExceptionsControllerFindAllByEmail(params: UserWeeklyScheduleExceptionsControllerFindAllByEmail$Params, context?: HttpContext): Observable<Array<ResponseUserWeeklyScheduleExceptionDto>> {
    return this.userWeeklyScheduleExceptionsControllerFindAllByEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponseUserWeeklyScheduleExceptionDto>>): Array<ResponseUserWeeklyScheduleExceptionDto> => r.body)
    );
  }

}
